// Components

import { MarkAsReadUnread } from '@/components/pages/conversations/SocialInbox/components/SocialInboxMessageList/SocialInboxHeader/SocialInboxActions/DirectMessageActions/MarkAsReadUnread';

export function DirectMessageActions() {
    return (
        <div className="flex space-x-3">
            <MarkAsReadUnread isRead={false} />
            <MarkAsReadUnread isRead />
        </div>
    );
}
